export default {
  DEVICE_MUTATIONS(state, { key, value }) {
    state[key] = value;
  },
};
